export default {
  SET_CURRENT_USER (state, currentUserData) {
    state.currentUser = currentUserData
  },

  SET_CURRENT_SESSION (state, currentSession) {
    state.currentSession = currentSession
  },

  SET_CURRENT_PERSON(state, person) {
    state.currentPerson = person;
  },

  SET_OWNER_PERSON(state, person) {
    state.ownerPerson = person;
  },

  RESET_CURRENT_PERSON_TO_DEFAULT(state) {
    console.log('RESET_CURRENT_PERSON_TO_DEFAULT', state.ownerPerson)
    if (state.ownerPerson && state.currentPerson !== state.ownerPerson) {
      state.currentPerson = state.ownerPerson;      
    }
  }
}
